import { environment } from "../environments/environment";

export function authHeader() {
  return {
    Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    Accept: "application/json",
    "Content-Type": "application/json; charset=utf-8",
  };
}

export function authHeaderFileUpload() {
  return {
    Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
  };
}

export function getApiUrl() {
  return environment.getAPIUrl();
}

export function getAuthToken() {
  return environment.token;
}
